import {BaseWrapper} from '../../../../allkey/framework/parameters/BaseWrapper';
import {BasicScenario} from '../../../../allkey/framework/parameters/BasicScenario';
import {ProcessStepExt} from '../message/ProcessStepExt';
import {ProcessStepExtCriteria} from './ProcessStepExtCriteria';

export class ProcessStepExtWrapper extends BaseWrapper<ProcessStepExt, ProcessStepExtCriteria, BasicScenario>  {}

